import { isEmpty } from "@/utils/stringUtil.js"

export const local = {
  get (key) {
    const val = window.localStorage.getItem(key)
    return isEmpty(val) ? '' : JSON.parse(window.localStorage.getItem(key))
  },
  getDef (key, def) {
    const val = window.localStorage.getItem(key)
    return isEmpty(val) ? def : JSON.parse(window.localStorage.getItem(key))
  },
  set (key, items) {
    window.localStorage.setItem(key, JSON.stringify(items))
  }
}
export const session = {
  get (key) {
    const val = window.sessionStorage.getItem(key)
    return isEmpty(val) ? '' : JSON.parse(window.sessionStorage.getItem(key))
  },
  set (key, items) {
     window.sessionStorage.setItem(key, JSON.stringify(items))
  }
}
